import { render, staticRenderFns } from "./Rainbow.vue?vue&type=template&id=19cc776d&scoped=true&"
import script from "./Rainbow.vue?vue&type=script&lang=js&"
export * from "./Rainbow.vue?vue&type=script&lang=js&"
import style0 from "./Rainbow.vue?vue&type=style&index=0&id=19cc776d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cc776d",
  null
  
)

export default component.exports